module.exports = __webpack_public_path__ + "img/popped-click.439414e6.png";